<template>
  <section id="newborn">
    <m-img src="@/v2/mobile/assets/image/h_70.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>
